import React from 'react';
import './SecondSection.css';
import { IMAGES } from '../../assets/image';

const SecondSection = () => {
  return (
    <section
      className="second-section"
      aria-labelledby="refinance-title"
    >
      <div className="second-top layout-container">
        <h5 className="second-subtitle" id="refinance-subtitle">
          REFINANCE & SAVE
        </h5>
        <h2 className="second-title" id="refinance-title">
          In less than 10 minutes, you can save thousands of dollars on your monthly car payment.
        </h2>
      </div>

      <div className="second-bottom">
        <div className="layout-container second-cards">
          <figure className="second-card-first">
            <img
              src={IMAGES.Checkmark}
              alt="No payments up to 90 days icon"
              className="checkmark-icon"
            />
            <figcaption className="second-text">
              Enjoy no payments for up to 90 days
            </figcaption>
          </figure>

          <figure className="second-card">
            <img
              src={IMAGES.Checkmark}
              alt="Lower car payments icon"
              className="checkmark-icon"
            />
            <figcaption className="second-text">
              Lower your car payment by as much as $150 a month
            </figcaption>
          </figure>

          <figure className="second-card-third">
            <img
              src={IMAGES.Checkmark}
              alt="No application fee icon"
              className="checkmark-icon"
            />
            <figcaption className="second-text">No fee to apply</figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default SecondSection;
